var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFocus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 6.25H32.5a1.25 1.25 0 011.25 1.25v4.375M28.125 33.75H32.5a1.25 1.25 0 001.25-1.25v-4.375M11.875 33.75H7.5a1.25 1.25 0 01-1.25-1.25v-4.375M11.875 6.25H7.5A1.25 1.25 0 006.25 7.5v4.375M20 22.5a5 5 0 100-10 5 5 0 000 10zM11.706 27.5a9.378 9.378 0 0116.588 0",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUserFocus;